import React from "react";
// import { Card } from 'react-bootstrap';
// import { Container, Row, Col } from 'react-bootstrap';
// import { Container, Row, Col } from 'react-bootstrap';
import './Products.css';

import prodlcmadbg from '../images/PageImg/ProductLcmAd-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { GoTopBtn } from '../components/GoTopBtn';

function ProductLcmAdBd() {
  return (
    <div className='products-page container-fluid'>
      <div className='productheader'
        style={{ backgroundImage: `url(${prodlcmadbg})`, height: "60vh" }} >
        {/* style={{ backgroundImage: `url(${prodlcmadbg})`, height: "auto" }} > */}
        <HeaderSlide text={'Product / LCM AD Board'} />
        <h4 className='text-light'>&nbsp;images/PageImg/ProductLcmAd-page-bg.jpg</h4>
      </div>
      <h1 className='prodlcmadbd'>Product/LCM AD Board</h1>
      <div> < GoTopBtn /> </div>
    </div>
  );
}

export default ProductLcmAdBd;